// extracted by mini-css-extract-plugin
export default {"themeToggle":"ThemeSwitcher_themeToggle__VKZX0","imgContainer":"ThemeSwitcher_imgContainer__RFB+q","toggle":"ThemeSwitcher_toggle__hpSXq"};